export default class FeedbackComment {
  constructor(FeedbackId) {
    // this.Id = null;
    this.FeedbackId = FeedbackId
    this.Text = null
    // this.CreatedAt = null;
  }
}
